import "../services.css"
import "../servicescovers.css"

import { useState, useRef, useEffect } from "react";
import { HelmetProvider } from 'react-helmet-async';
import R from "../../../assets/Images/Quote/Hero-Section.jpg"

import Arrow from "../../../assets/Images/Elements/Arrow_O1.svg"

import Header from "../../../assets/components/01_header/header"
import Footer from "../../../assets/components/02_footer/footer"
import QuotationComponent from "../../../assets/components/06_quotation_component/quotation_component"
import test from "../../../assets/Images/Elements/M-Orange.svg"

export default function DigitalMarketingStrategy() {
    const [stepT, setStepT] = useState(1);
    const TOTAL_SLIDES = 8;

    const selectorRef = useRef(null);
    const itemRefs = useRef([]);

    const autoSlideRef = useRef(null);
    const pauseTimeoutRef = useRef(null);

    const scrollToItem = (index) => {
        const item = itemRefs.current[index];
        const container = selectorRef.current;

        if (!item || !container) return;

        const itemLeft = item.offsetLeft;
        const containerWidth = container.offsetWidth;
        const itemWidth = item.offsetWidth;

        container.scrollTo({
            left: itemLeft - containerWidth / 2 + itemWidth / 2,
            behavior: "smooth",
        });
    };

    useEffect(() => {
        startAutoSlide();
        return stopAutoSlide;
    }, []);

    const startAutoSlide = () => {
        stopAutoSlide();
        autoSlideRef.current = setInterval(() => {
            setStepT(prev => (prev === TOTAL_SLIDES ? 1 : prev + 1));
        }, 5000);
    };

    const stopAutoSlide = () => {
        if (autoSlideRef.current) {
            clearInterval(autoSlideRef.current);
            autoSlideRef.current = null;
        }
    };

    const pauseAutoSlide = () => {
        stopAutoSlide();

        if (pauseTimeoutRef.current) {
            clearTimeout(pauseTimeoutRef.current);
        }

        pauseTimeoutRef.current = setTimeout(() => {
            startAutoSlide();
        }, 4000);
    };

    useEffect(() => {
        scrollToItem(stepT - 1);
    }, [stepT]);

    return (
        <div>
            <HelmetProvider>
                <title>Strategic Digital Marketing Solutions for Businesses in Mumbai</title>
                <meta name="Adstrate is a digital marketing agency in Mumbai offering digital marketing strategy, social media marketing in Mumbai, Instagram marketing agency, and content creation services for growth." />
                <link rel="canonical" href="https://adstrate.in/services/digital-marketing-strategy" />
            </HelmetProvider>
            <Header />
            <div className="ServicesDetails-HeroSection ServicesDetails-HeroSection-Website">
                <div className="ServicesDetails-HeroSection-Glass">
                    <h1>Digital Marketing Strategy</h1>
                    <p>Adstrate, a trusted digital marketing agency in Mumbai, delivers comprehensive digital marketing strategies that help businesses achieve measurable growth. </p>
                    <a href="/quotation">
                        <p className="LinkLabel">Get Quote</p>
                        <img src={Arrow}/>
                    </a>
                </div>
            </div>
            <div className="ServicesPages-Services-Main">
                <div className="ServicesPages-Services-Info">
                    <div className={`ServicesPages-Services-Info-Cards Home-fade ${stepT === 1 ? "Home-show" : ""}`}>
                        <div className="ServicesPages-Services-Info-Cards-Main">
                            <h2>Discovery & Business Audit</h2>
                            <p>
                                Assess brand positioning, competitors, audience, and marketing performance.
                            </p>
                            <div className="ServicesPages-Services-Selector-Img">
                            </div>
                        </div>
                    </div>
                    <div className={`ServicesPages-Services-Info-Cards Home-fade ${stepT === 2 ? "Home-show" : ""}`}>
                        <div className="ServicesPages-Services-Info-Cards-Main">
                            <h2>Strategic Planning</h2>
                            <p>
                                Select channels, define messaging frameworks, and design marketing funnels. 
                            </p>
                            <div className="ServicesPages-Services-Selector-Img">
                            </div>
                        </div>
                    </div>
                    <div className={`ServicesPages-Services-Info-Cards Home-fade ${stepT === 3 ? "Home-show" : ""}`}>
                        <div className="ServicesPages-Services-Info-Cards-Main">
                            <h2>Content & Social Media Integration</h2>
                            <p>
                                Plan content and social campaigns aligned with business objectives.
                            </p>
                            <div className="ServicesPages-Services-Selector-Img">
                            </div>
                        </div>
                    </div>
                    <div className={`ServicesPages-Services-Info-Cards Home-fade ${stepT === 4 ? "Home-show" : ""}`}>
                        <div className="ServicesPages-Services-Info-Cards-Main">
                            <h2>SEO & Paid Advertising Alignment</h2>
                            <p>
                                Integrate SEO and paid campaigns for a holistic marketing approach.
                            </p>
                            <div className="ServicesPages-Services-Selector-Img">
                            </div>
                        </div>
                    </div>
                    <div className={`ServicesPages-Services-Info-Cards Home-fade ${stepT === 5 ? "Home-show" : ""}`}>
                        <div className="ServicesPages-Services-Info-Cards-Main">
                            <h2>Execution Roadmap</h2>
                            <p>
                                Deliver clear, actionable strategy documents and prioritization guidance.
                            </p>
                            <div className="ServicesPages-Services-Selector-Img">
                            </div>
                        </div>
                    </div>
                    <div className={`ServicesPages-Services-Info-Cards Home-fade ${stepT === 6 ? "Home-show" : ""}`}>
                        <div className="ServicesPages-Services-Info-Cards-Main">
                            <h2>Review & Feedback</h2>
                            <p>
                                Ensure alignment with stakeholders and clarity before implementation.
                            </p>
                            <div className="ServicesPages-Services-Selector-Img">
                            </div>
                        </div>
                    </div>
                    <div className={`ServicesPages-Services-Info-Cards Home-fade ${stepT === 7 ? "Home-show" : ""}`}>
                        <div className="ServicesPages-Services-Info-Cards-Main">
                            <h2>Offboarding & Documentation</h2>
                            <p>
                               Provide final strategy documentation, recommendations, and next steps.
                            </p>
                            <div className="ServicesPages-Services-Selector-Img">
                            </div>
                        </div>
                    </div>
                    <div className={`ServicesPages-Services-Info-Cards Home-fade ${stepT === 8 ? "Home-show" : ""}`}>
                        <div className="ServicesPages-Services-Info-Cards-Main">
                            <h2>Continued Engagement Guidance</h2>
                            <p>
                                Suggest implementation priorities or ongoing partnership options for growth.
                            </p>
                            <div className="ServicesPages-Services-Selector-Img">
                            </div>
                        </div>
                    </div>
                </div>
                <div className="ServicesPages-Services-Selector" ref={selectorRef}>
                    <div className="ServicesPages-Services-Selector-Selection">
                        {[
                        "Discovery & Business Audit",
                        "Strategic Planning",
                        "Content & Social Media Integration",
                        "SEO & Paid Advertising Alignment",
                        "Execution Roadmap",
                        "Review & Feedback",
                        "Offboarding & Documentation",
                        "Continued Engagement Guidance",

                        ].map((text, index) => (
                        <div
                            key={index}
                            ref={(el) => (itemRefs.current[index] = el)}
                            className={stepT === index + 1 ? "ServicesPages-Services-Selector-Card Home-active MicroLinksText" : "ServicesPages-Services-Selector-Card"}
                            onClick={() => {
                                pauseAutoSlide();
                                setStepT(index + 1);
                                scrollToItem(index);
                            }}
                        >
                            <div className="ServicesPages-Services-Selector-selection"></div>
                            <div className="ServicesPages-Services-Selector-hover"></div>
                            <p>{text}</p>
                        </div>
                        ))}
                    </div>
                </div>
            </div>
            <QuotationComponent />
            <Footer />
        </div>
    );
}